export const LOGIN_API = process.env.REACT_APP_LOGIN_API || "";
export const METRICS_API = process.env.REACT_APP_METRICS_API;
export const STATS_API = process.env.REACT_APP_STATS_API;
export const API = process.env.REACT_APP_API_URL;
export const MEDIA_SERVER = process.env.REACT_APP_MEDIA_SERVER_URL;
export const FASTDRAW_URL = process.env.REACT_APP_FASTDRAW_URL;
export const SYNERGY_URL = process.env.REACT_APP_SYNERGY_URL;
export const FAST_SERVER_URL = process.env.REACT_APP_FAST_SERVER_URL;
export const HUDL_ID_URL = process.env.REACT_APP_HUDL_IDENTITY_URL || "";

export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const HUDL_CLIENT_ID_DRAW = process.env.REACT_APP_HUDL_CLIENT_ID_DRAW;

export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
export const SUPPORT_URL = process.env.REACT_APP_SUPPORT_URL;

export const SUPPORT_EMAIL = "support@fastmodelsports.com";
export const SUPPORT_LINK = "https://support.hudl.com/s/contactsupport?language=en_US";

export const DEFAULT_DRAFT_COLORS = ["#FFD400", "#008000", "#f32415"];

export const X_PAGE = "X-FMT-Page";
export const X_NUM_OF_PAGES = "X-FMT-PageCount";
export const X_TOTAL_ROWS = "X-FMT-TotalRows";

export const DEFAULT_PLAY_PAGE_SIZE = 40;
export const DEFAULT_PLAYBOOK_PAGE_SIZE = 40;
